export default __webpack_public_path__ + "static/media/user.a0aafe81.svg";